import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { id: String };

  show() {
    const element = document.getElementById(this.idValue);
    element.hidden = false;
    element.querySelector("input, textarea")?.focus();
    this.element.hidden = true;
  }
}
